export interface AccountInfoData {
  id: number;
  email_address: string;
  display_name: string;
  coins: number;
  is_confirmed: boolean;
}

export interface AccountContextData {
  accountInfo: AccountInfoData;
  message: string;
  error: string;
  loading: boolean;
  loaded: boolean;
  socialSignup: boolean;
  isLoggedIn: boolean;
}

export const initialState = {
  accountInfo: {
    id: -1,
    email_address: '',
    display_name: '',
    coins: -1,
    is_confirmed: false,
  },
  message: '',
  error: '',
  loading: false,
  loaded: false, // only set to true once we've hit the API and know if user is logged in
  socialSignup: false,
  isLoggedIn: false,
};

export const ACCOUNT_FETCH_FAILED = 'ACCOUNT_FETCH_FAILED';
export const ACCOUNT_FETCH_REQUESTED = 'ACCOUNT_FETCH_REQUESTED';
export const ACCOUNT_FETCH_SUCCEEDED = 'ACCOUNT_FETCH_SUCCEEDED';
export const LOG_IN_REQUESTED = 'LOG_IN_REQUESTED';
export const LOG_IN_SUCCEEDED = 'LOG_IN_SUCCEEDED';
export const LOG_IN_FAILED = 'LOG_IN_FAILED';
export const SIGN_UP_REQUESTED = 'SIGN_UP_REQUESTED';
export const SIGN_UP_SUCCEEDED = 'SIGN_UP_SUCCEEDED';
export const SIGN_UP_FAILED = 'SIGN_UP_FAILED';
export const PASSWORD_RESET_REQUESTED = 'PASSWORD_RESET_REQUESTED';
export const PASSWORD_RESET_SUCCEEDED = 'PASSWORD_RESET_SUCCEEDED';
export const PASSWORD_RESET_FAILED = 'PASSWORD_RESET_FAILED';
export const LOG_OUT = 'LOG_OUT';
export const CLEAR_MESSAGING = 'CLEAR_MESSAGING';

export const AuthReducer = (state: AccountContextData, action: any) => {
  let account, accountInfo;
  switch (action.type) {
    case LOG_IN_REQUESTED:
    case SIGN_UP_REQUESTED:
    case PASSWORD_RESET_REQUESTED:
    case ACCOUNT_FETCH_REQUESTED:
      return { ...state, loading: true };

    case LOG_IN_SUCCEEDED:
    case SIGN_UP_SUCCEEDED:
    case ACCOUNT_FETCH_SUCCEEDED:
      account = action?.payload?.account || {};
      accountInfo = account.id && account.id !== -1 ? account : initialState.accountInfo;
      return {
        ...state,
        loading: false,
        loaded: true,
        error: '',
        message: account?.payload?.message || '',
        accountInfo,
        isLoggedIn: true,
      };

    case LOG_IN_FAILED:
    case SIGN_UP_FAILED:
    case PASSWORD_RESET_FAILED:
    case ACCOUNT_FETCH_FAILED:
      return {
        ...initialState,
        message: action?.payload?.message || '',
        error: action?.payload?.error || '',
        loading: false,
        loaded: true,
      };

    case PASSWORD_RESET_SUCCEEDED:
      return {
        ...initialState,
        loading: false,
        loaded: true,
        message: action?.payload?.message || '',
      };

    case LOG_OUT:
      return { ...initialState };

    case CLEAR_MESSAGING:
      return {
        ...state,
        error: undefined,
        message: undefined,
      };

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};
